module.exports = __webpack_public_path__ + "img/icon-security.348daf12.svg";